window.cartHelpers = {
    async addToCart(vm, product) {
        if (product._adding) return;
        product._adding = true;

        const originalState = {
            isCart: product.isCart,
            cartQuantity: product.cartQuantity
        };

        product.isCart = true;
        product.cartQuantity = 1;

        try {
            if (window.globalState.isAuth) {
                const data = await this.api(window.laravelConfig.routes.addToCart, {
                    product_id: product.id,
                    quantity: 1
                });

                if (!data.success) Object.assign(product, originalState);
            } else {
                this.addToLocalStorageCart(product, 1);
            }

            window.globalState.updateSingleCartProduct(product);

        } catch (e) {
            Object.assign(product, originalState);
        } finally {
            product._adding = false;
        }
    },

    async updateCartQuantity(vm, product, change, value) {
        const originalQuantity = product.cartQuantity;

        let newQuantity = value !== undefined
            ? Math.max(0, Math.min(product.sumAllStocks, parseInt(value) || 0))
            : Math.max(0, Math.min(product.sumAllStocks, product.cartQuantity + change));

        if (newQuantity === 0) product.isCart = false;

        product.cartQuantity = newQuantity;

        if ( newQuantity > product.sumAllStocks ) {
            globalState.addNotification(
                "Достигнуто максимальное количество товара на складе."
            );
            return;
        }


        window.globalState.updateSingleCartProduct(product);

        this.debouncedCartUpdate(product, newQuantity, originalQuantity);
    },

    debouncedCartUpdate(product, newQty, oldQty) {
        if (!this.updateTimeouts) this.updateTimeouts = new Map();

        clearTimeout(this.updateTimeouts.get(product.id));

        const timeoutId = setTimeout(() => {
            this.executeServerUpdate(product, newQty, oldQty);
            this.updateTimeouts.delete(product.id);
        }, 300);

        this.updateTimeouts.set(product.id, timeoutId);
    },

    async executeServerUpdate(product, newQty, oldQty) {
        try {
            if (window.globalState.isAuth) {
                const data = await this.api(window.laravelConfig.routes.updateCart, {
                    product_id: product.id,
                    quantity: newQty
                });

                if (!data.success) {
                    product.cartQuantity = oldQty;
                    return;
                }

            } else {
                newQty === 0
                    ? this.removeFromLocalStorageCart(product.id)
                    : this.updateLocalStorageCart(product.id, newQty);
            }

            window.globalState.updateSingleCartProduct(product);

        } catch {
            product.cartQuantity = oldQty;
        }
    },

    getLocalStorageCart() {
        try {
            return JSON.parse(localStorage.getItem("cart")) || [];
        } catch {
            return [];
        }
    },

    addToLocalStorageCart(product, qty = 1) {
        const cart = this.getLocalStorageCart();
        const item = cart.find(x => x.product_id === product.id);

        if (item) item.quantity += qty;
        else cart.push({ product_id: product.id, quantity: qty, price: product.price });

        this.saveLocalStorageCart(cart);
    },

    updateLocalStorageCart(id, qty, price) {
        const cart = this.getLocalStorageCart();
        const item = cart.find(x => x.product_id === id);
        if (!item) return;

        item.quantity = qty;
        if (price !== undefined) item.price = price;

        this.saveLocalStorageCart(cart);
    },

    removeFromLocalStorageCart(id) {
        const cart = this.getLocalStorageCart().filter(x => x.product_id !== id);
        this.saveLocalStorageCart(cart);
    },

    saveLocalStorageCart(cart) {
        localStorage.setItem("cart", JSON.stringify(cart));
        window.globalState.cart.isLoaded = false;
        window.globalState.loadCart();
    },

    async syncCartOnLogin() {
        if (!window.globalState.isAuth) return;

        const localCart = this.getLocalStorageCart();
        if (!localCart.length) return;

        const data = await this.api(window.laravelConfig.routes.addToCart, {
            items: localCart
        });

        if (data.success) localStorage.removeItem("cart");
    },

    initializeProductCartState(products) {
        const cartMap = new Map(
            this.getLocalStorageCart().map(i => [i.product_id, i.quantity])
        );

        products.forEach(p => {
            const qty = cartMap.get(p.id);
            p.isCart = !!qty;
            p.cartQuantity = qty || 0;
        });

        return products;
    },

    cartCache: { total: 0, count: 0, lastUpdate: null },

    updateCartCache(products) {
        const cartItems = products.filter(p => p.isCart);

        this.cartCache.total =
            cartItems.reduce((s, p) => s + p.price * p.cartQuantity, 0);

        this.cartCache.count =
            cartItems.reduce((s, p) => s + p.cartQuantity, 0);

        this.cartCache.lastUpdate = Date.now();
    },

    getCachedCartTotal() { return this.cartCache.total },
    getCachedCartCount() { return this.cartCache.count },

    async api(url, payload) {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": window.laravelConfig.csrfToken
            },
            body: JSON.stringify(payload)
        });

        return response.json();
    }
};